
import { mapState, mapMutations } from "vuex";
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import InlineXNumber from 'vux/src/components/inline-x-number/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import Norm from '../../components/card/norm'
import { goodProduct, getProductPic, addCart, getCartNum , campaignRule} from '../../service/index'
import { productCombine } from '../../utils/storage'

export default {
data() {
return {
moveDistance: 60,
rule:{},
count: 1,
spec: null,
productPic: [],
products: {},
select: 0,
showError: false,
errorMsg: '',
showSuccess: false,
successMsg: '',
badgeAnimation:false
};
},
components:{
Swiper, SwiperItem, Norm, InlineXNumber, Toast
},
created() {
this.changeVisible()
this.getCartNum()
this.keepLang()
this.getCampaignRuleInfo()
},
computed: {
...mapState([
'categories', 'cartList', 'campaign', 'global'
]),
product() {
return this.productAndPic.length > 0 ? this.productAndPic[this.select] : {}
},

productAndPic() {
const result = [];
this.productPic.map((item) => {
this.products.map((good) => {
if (item.productId === good.id) {
result.push({ ...item, ...good })
}
})
})
return result;
},
},

methods: {

...mapMutations({
initCart: 'INIT_CART_NUM',
initCartNum: 'INIT_CART_NUM',
}),
async getCampaignRuleInfo() {
const res = await campaignRule(this.$route.query.cid);
if (res.status === 0) {
this.rule = res.data
}
},
keepLang(){
let locale = localStorage.locale;
this.$i18n.locale = locale === 'en' ? locale : 'zh';
},
async changeVisible() {
const goodId = this.$route.query.id;
const products = await goodProduct(goodId);
this.spec = productCombine(products.data);
this.products = products.data;
const productPicture = await getProductPic(goodId)
this.productPic = productPicture.data;
this.isShow = true
},
async addProToCart(goodId) {
const param = {
"items": [
{
"productId": goodId,
"qty": this.count
}
]
}
const res = await addCart(this.$route.query.cid, param);
if (res.status === 0) {
this.initCart({
cartNum: this.count + this.cartList.cartNum,
})
this.badgeAnimation=true
setTimeout(()=>{
this.badgeAnimation=false
},1000)
this.successMsg = this.$t('cartMsg.success');
this.showSuccess = true;





}else if (res.status === 2) {
this.errorMsg = this.$t("cartMsg.lackall");
this.showError = true;
} else if (res.status === 3) {
this.submitFlag = false
this.errorMsg = this.$t("cartMsg.lackall");
this.showError = true;
} else if (res.status === 4) {
this.submitFlag = false
this.errorMsg = this.$t("cartMsg.globalamount");
this.showError = true;
} else if (res.status === 5) {
this.submitFlag = false
this.errorMsg = this.$t("cartMsg.perskuqty");
this.showError = true;
} else if (res.status === 6) {
this.submitFlag = false
this.errorMsg = this.$t("cartMsg.globalqty");
this.showError = true;
} else if (res.status === 7) {
this.submitFlag = false
this.errorMsg = this.$t("cartMsg.typeqty");
this.showError = true;
} else if (res.status === 8) {
this.submitFlag = false
this.errorMsg = this.$t("cartMsg.catqty");
this.showError = true;
}  else if (res.status === 9) {
this.submitFlag = false
this.errorMsg = this.$t("cartMsg.orderqty");
this.showError = true;
} else if (res.status === 10) {
this.submitFlag = false
this.errorMsg = this.$t("cartMsg.pointlack");
this.showError = true;
}  else if(res.status === 11){
this.submitFlag = false
this.errorMsg = (this.$t("cartMsg.personalamount"));
this.showError = true;
}else {
this.submitFlag = false
this.errorMsg = this.$t("cartMsg.retry");
this.showError = true;
}
},
async getCartNum() {
const cartNum = await getCartNum(this.$route.query.cid)
this.initCartNum({ cartNum: cartNum.data })
},
goHome(){
this.$router.push({
path: `/home/${this.$route.query.cid}`,
query: {
cid: this.$route.query.cid
}
})
},
goCart(){
this.$router.push({
path: '/cart',
query: {
cid: this.$route.query.cid
}
})
}
}
};



// WEBPACK FOOTER //
// ./src/pages/good/DetailMb.vue